<template>
  <div style="padding-bottom: 1em;">
    <el-table
      :data = "tabledatas"
      border
      style = "width: 100%; font-size: medium ;"
      :show-header=false
      >
      <el-table-column prop="col1" label="Key" width="120" />
      <el-table-column prop="col2" label="Value">
        <template slot-scope="scope">
          <span v-if="external(scope.row.col2)">
            <el-link type="warning" :href="scope.row.col2.split('?')[0]" target="_blank" class="buttonText">{{ scope.row.col2.split('?')[1] }}</el-link> 
          </span>
          <span v-else-if="scope.row.col2.constructor === Array">
            <span v-for="(item,index) of scope.row.col2">
              <el-link 
                :type="colortype[index]"  
                :href="'/static/pdf/' + item"
                target="_blank" class="buttonText"
              >{{ item }}
            </el-link>&nbsp;
            </span>
          </span>
          <span v-else>{{ scope.row.col2 }}</span>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <div v-html="mdDatas" class="markdown-body"></div>
  </div>
</template>

<script>

import 'github-markdown-css/github-markdown.css';
import { isExternal } from '@/utils/validate';

export default {
  data() {
    return {
      colortype: ['success','primary','danger','warning'],
    }
  },
  props:{
    mdDatas: {
      type: String,
      required: true
    },
    tabledatas: {
      type: Array,
      required: true
    }
  },
  methods: {
    external(path){
      if(isExternal(path)) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/DataInfo/index.vue